const BOOKSTORE_BASE_URL = 'https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/ZA4hiFyWSfvlWcHLNCyN';

export default BOOKSTORE_BASE_URL;
